import {useEffect} from 'react'

export const useTitle = (title) => {

  useEffect(() => {
    document.title = `ADSIL | ${title}`;
  }, [title]);
  
  return null;
}
